import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { providerApiClient } from '@/lib/api'
import { availabilityKeys } from '@/lib/queryKeys'
import type { Availability } from '@/types/availability'

export function useAvailability() {
  return useQuery({
    queryKey: availabilityKeys.current(),
    queryFn: () => providerApiClient.getAvailability(),
    staleTime: 5 * 60 * 1000,
  })
}

export function useUpdateAvailability() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: Availability) => providerApiClient.updateAvailability(data),
    onSuccess: (data) => {
      queryClient.setQueryData(availabilityKeys.current(), data)
    },
  })
}
